<template>
  <div class="kye-preview-file-image" :style="itemStyle" :class="{ 'is-big-size': isBigSize }">
    <slot name="previewFileItem" :fileName="fileName" :url="url" :extendName="extendName">
      <el-image
        class="kye-preview-file-image-img"
        :src="url">
        <div slot="error" class="kye-preview-file-image-img-error">
          <img :src="fileImg" alt="" />
        </div>
      </el-image>
      <div class="kye-preview-file-image-info">
        <el-tooltip popper-class="kye-dark" :content="name" placement="top">
          <span class="kye-preview-file-image-info-name">{{ name }}</span>
        </el-tooltip>
      </div>
      <div class="kye-preview-file-image-tools-close" v-if="canRemove">
        <img src="./images/image-close.png" alt="" @click.stop="remove" />
      </div>
      <div class="kye-preview-file-image-tools">
        <div class="kye-preview-file-image-tools-icon is-preview" @click.stop="preview" v-if="canPreview">
          <img src="./images/image-preview.png" alt="" />
          <span v-if="isBigSize">预览</span>
        </div>
        <div class="kye-preview-file-image-tools-icon is-download" @click.stop="download" v-if="canDownload">
          <img src="./images/image-download.png" alt="" />
          <span v-if="isBigSize">下载</span>
        </div>
      </div>
    </slot>
  </div>
</template>

<script>
import { getImgSuffix, getExtendName } from './utils'

export default {
  props: {
    url: {
      type: String,
      default: ''
    },
    fileName: {
      type: String,
      default: ''
    },
    extendName: {
      type: String,
      default: ''
    },
    size: [Number, String, Array], // 宽*高
    canDownload: {
      type: Boolean,
      default: true
    },
    canRemove: {
      type: Boolean,
      default: true
    },
    canPreview: {
      type: Boolean,
      default: true
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  },
  computed: {
    name () {
      return this.fileName || '无文件名'
    },
    fileImg () {
      const { fileName, extendName } = this
      const imgType = extendName || getExtendName(fileName)
      return getImgSuffix(imgType)
    },
    itemStyle () {
      let s = this.$props.size || 64
      if (!Array.isArray(s)) {
        s = [s, s]
      }
      return {
        'width': parseInt(s[0]) + 'px',
        'height': parseInt(s[1]) + 'px',
      }
    },
    isBigSize () {
      let s = this.$props.size || 64
      if (Array.isArray(s)) {
        s = s[0]
      }
      return s >= 128
    }
  },
  methods: {
    // 预览
    preview () {
      if (!this.canPreview) {
        return
      }
      this.$emit('preview', {
        url: this.url,
        fileName: this.fileName,
        extendName: this.extendName,
        id: this.id
      })
    },
    // 下载
    download () {
      if (!this.canDownload) {
        return
      }
      this.$emit('download', {
        url: this.url,
        fileName: this.fileName,
        extendName: this.extendName,
        id: this.id
      })
    },
    // 删除
    remove () {
      if (!this.canRemove) {
        return
      }
      this.$emit('remove', {
        url: this.url,
        fileName: this.fileName,
        extendName: this.extendName,
        id: this.id
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .kye-preview-file-image {
    width: 64px;
    height: 64px;
    border: 1px solid var(--g-border-color);
    border-radius: var(--g-border-radius);
    background-color: var(--g-bg-gray);
    margin-right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    &:hover {
      .kye-preview-file-image-tools {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        gap: 4px;
        border-radius: var(--g-border-radius);
        background-color: rgba(0, 0, 0, 0.6);
      }
      .kye-preview-file-image-info {
        z-index: 9;
      }
      &.is-big-size {
        .kye-preview-file-image-tools {
          gap: 12px;
        }
      }
    }
    &-img {
      height: 100%;
      /deep/ &-error {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        img {
          width: 30px;
        }
      }
      /deep/ .el-image__inner {
        width: 100%;
        height: 100%;
        object-fit: contain;  /* 保持比例，完整显示 */
      }
    }
    &-info {
      position: absolute;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      background-color: rgba(29, 28, 35, 0.4);
      color: #fff;
      padding: 2px 4px;
      border-bottom-left-radius: var(--g-border-radius);
      border-bottom-right-radius: var(--g-border-radius);
      &-name {
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    &.is-big-size {
      .kye-preview-file-image-info {
        padding: 5px;
      }
      .kye-preview-file-image-img-error img {
        width: 60px;
        height: 60px;
      }
    }
    &-tools {
      display: none;
      position: absolute;
      &-icon {
        cursor: pointer;
        &.is-preview,
        &.is-download {
          padding: 4px;
          border-radius: var(--g-border-radius);
          &:hover {
            background: rgba(29, 28, 35, 0.16);
          }
          &:active {
            background: rgba(29, 28, 35, 0.24);
          }
        }
        img {
          width: 12px;
          // height: 12px;
        }
        span {
          color: #fff;
        }
      }
      &-close {
        position: absolute;
        top: -6px;
        right: -6px;
        cursor: pointer;
        z-index: 1;
        img {
          width: 18px;
          height: 18px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/kye-preview/component/file-image.vue